import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import React from "react";
import CustomButton from "./CustomButton";

export default function AlertDialog({ open, setOpen, title, message }) {
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog 
            open={open} 
            onClose={handleClose} 
            aria-labelledby="alert-dialog-title" 
            aria-describedby="alert-dialog-description" 
            maxWidth="sm" 
            fullWidth
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                {message && (
                    <DialogContentText id="alert-dialog-description">
                        {Array.isArray(message) ? (
                            message.map((line, index) => (
                                <div key={index} style={{ marginBottom: index < message.length - 1 ? '8px' : '0' }}>
                                    {line}
                                </div>
                            ))
                        ) : (
                            <div style={{ whiteSpace: 'normal', overflow: 'visible', wordBreak: 'break-word' }}>
                                {message}
                            </div>
                        )}
                    </DialogContentText>
                )}
            </DialogContent>
            <DialogActions style={{ display: "flex", justifyContent: "center", m: 2 }}>
                <CustomButton 
                    variant="contained" 
                    onClick={handleClose} 
                    color="primary"
                    autoFocus
                >
                    OK
                </CustomButton>
            </DialogActions>
        </Dialog>
    );
}
